import React from 'react';
import classNames from 'classnames';

export default function BaseTextArea({ className, rows = 4, ...props }) {
  const textAreaClassNames = classNames(
    'block w-full rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6',
    {
      'opacity-50 cursor-not-allowed disabled:bg-gray-400': props.disabled,
    },
    className
  );

  return (
    <textarea
      rows={rows}
      {...props}
      className={textAreaClassNames}
    />
  );
}
